import { Base_Url } from "../../BaseURL/BaseUrl";
import {
  getApiWithAuthorization,
  postApiWithAuthorization,
} from "../ApiMethods/ApiMethod";

const ServiceUrl = `${Base_Url}/Service`;

export const GetServiceList = async (params) => {
  const res = await postApiWithAuthorization(
    `${ServiceUrl}/GetServiceList`,
    params
  );
  return res;
};

export const AddUpdateService = async (params) => {
  const res = await postApiWithAuthorization(
    `${ServiceUrl}/AddUpdateService?ModuleName=${params.ModuleName}`,
    params
  );
  return res;
};
export const GetServiceModel = async (ModuleName, KeyID, AdminKeyID) => {
  const res = await getApiWithAuthorization(
    `${ServiceUrl}/GetServiceModel?ModuleName=${ModuleName}&AdminKeyID=${AdminKeyID}&ServiceKeyID=${KeyID}`
  );
  return res;
};

export const ChangeServiceStatus = async (ModuleName, KeyID, AdminKeyID) => {
  const res = await getApiWithAuthorization(
    `${ServiceUrl}/ChangeServiceStatus?ModuleName=${ModuleName}&AdminKeyID=${AdminKeyID}&ServiceKeyID=${KeyID}`
  );
  return res;
};

export const DeleteService = async (ModuleName, KeyID, AdminKeyID) => {
  const res = await getApiWithAuthorization(
    `${ServiceUrl}/DeleteService?ModuleName=${ModuleName}&AdminKeyID=${AdminKeyID}&ServiceKeyID=${KeyID}`
  );
  return res;
};

export const GetServiceLookupList = async (
  ModuleName,
  CustomerIndustryID,
  AdminKeyID
) => {
  const res = await getApiWithAuthorization(
    `${ServiceUrl}/GetServiceLookupList?ModuleName=${ModuleName}&AdminKeyID=${AdminKeyID}&CustomerIndustryID=${CustomerIndustryID}`
  );
  return res;
};
